// src/pages/LandingPage.jsx
// Main landing page - composes all sections

import React from 'react';
import Hero from '../components/sections/Hero';
import StatsBar from '../components/sections/StatsBar';
import Products from '../components/sections/Products';
import About from '../components/sections/About';
import FAQ from '../components/sections/FAQ';
import CTA from '../components/sections/CTA';

const LandingPage = () => {
  return (
    <>
      <Hero />
      <StatsBar />
      <Products />
      <About />
      <FAQ />
      <CTA />
    </>
  );
};

export default LandingPage;